import React, { useState,useEffect } from "react";
import Navbar from "./Navbar";
import ReactPaginate from "react-paginate";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
function AllJobsPage() {
    const ID = Cookies.get("log_id");
    const [jobs,setJobs] = useState([]);
    function Fetch_All_Jobs() {
        axios.get(`${url.path}/fetch_all_jobs/`)
        .then((res) =>{
            if(res.data.status){
                var job = res.data.jobs;
                setJobs([])
                job.map((p)=>{
                    setJobs((prevState) =>[
                        ...prevState, p
                    ])
                })
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    useEffect(() =>{
        Fetch_All_Jobs();
    }, [])
        const itemsPerPage = 3;
        const [searchTerm, setSearchTerm] = useState("");
        const [currentPage, setCurrentPage] = useState(0);
    
        const filteredData = jobs.filter((item) =>
          item.Job_Name.toLowerCase().includes(searchTerm.toLowerCase())
        );
    
        const offset = currentPage * itemsPerPage;
        const currentItems = filteredData.slice(offset, offset + itemsPerPage);
        const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    
        const handlePageClick = ({ selected }) => {
          setCurrentPage(selected);
        };
        function searchTable(){
          var rows = document.querySelectorAll('#productstable tbody tr');
          var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
          rows.forEach(function(row) {
            var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
            row.style.display = text.includes(val) ? '' : 'none';
          });
        }
        const [companies,setCompanies] = useState([]);
        const [jobtype,setJobtype] = useState([]);
        function all_companies() {
            axios.get(`${url.path}/all_companies/`)
            .then((res) =>{
                if(res.data.status){
                    var cmp = res.data.companies;
                    // var job_type = res.data.jobs;
                    setCompanies([])
                    cmp.map((p)=>{
                        setCompanies((prevState) =>[
                            ...prevState, p
                        ])
                    })
                    // setJobtype([])
                    // job_type.map((j)=>{
                    //     setJobtype((prevState) =>[
                    //         ...prevState, j
                    //     ])
                    // })
                }
            }).catch((err) => {
                console.log("ERROR", err);
              });
        }
        useEffect(() =>{
            all_companies();
        }, [])
        const [JOB,setJOB] = useState("");
        const [COMPANY,setCOMPANY] = useState("");
        const [isFilterOpen, setIsFilterOpen] = useState(false);
                const [filters, setFilters] = useState({
                  company: "all",
                  jobtype: "all",
                 
                });
              
                const toggleFilter = () => setIsFilterOpen(!isFilterOpen);
              
                const handleFilterChange = (e) => {
                  const { name, value } = e.target;
                  setFilters({ ...filters, [name]: value });
                };
              
                const clearFilters = () => {
                  setCOMPANY("");
                  setJOB("");
                  toggleFilter();
                };
              
                function applyFilters() {
                    axios.get(`${url.path}/filter_jobs/`,{
                        params:{
                            company:COMPANY,
                            jobtype:JOB
                        }
                    })
                    .then((res) =>{
                        if(res.data.status){
                            var jobs = res.data.jobs;
                            setJobs([])
                            jobs.map((p)=>{
                                setJobs((prevState) =>[
                                    ...prevState, p
                                ])
                            })
                            // setIsFilterOpen(false);
                        }
                    }).catch((err) => {
                        console.log("ERROR", err);
                      });
                }
              
    return(
        <>
        <Navbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>All Jobs</h3>
            </center>
            <div className="search-container">
    <input
      type="text"
      placeholder="Search..."
      onKeyUp={searchTable}
      className="search-input"
      id="search"
    />
  </div>
            <div className="table-container">
            
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
            <div style={{ position: "relative",marginLeft:'auto' }}>
              <button className="filter-button" onClick={toggleFilter}>
                Filter <span>▼</span>
              </button>
              {isFilterOpen && (
                <div className="filter-panel">
                  <div>
                    <label>Company:</label>
                    <select name="company" value={COMPANY} onChange={(e) =>setCOMPANY(e.target.value)}>
                      <option value="all">All</option>
                      {companies.map((company) => (
                        <option key={company.id} value={company.Company_name}>
                          {company.Company_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label>Job Type:</label>
                    <select name="graduation" value={JOB} onChange={(e) =>setJOB(e.target.value)}>
                      <option value="all">All</option>
                      <option value="OpenSource">Open Source</option>
                      <option value="ExactSource">Exact Source</option>
                    </select>
                  </div>
                  <div className="filter-actions">
                    <button onClick={clearFilters}>Clear</button>
                    <button onClick={applyFilters}>Apply</button>
                  </div>
                </div>
              )}
            </div>
          </div>
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name</th>
            <th>Description</th>
            <th>Last Date</th>
            <th>Job Type</th>
            <th>Applicants Count</th>
          </tr>
        </thead>
        <tbody>
          {jobs.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Job_Name}</td>
              <td>{i.Description}</td>
              <td>{i.Last_Date_Apply}</td>
              <td>{i.Job_Type}</td>
                <td>{i.Number_Applicants}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default AllJobsPage;